module.exports = __webpack_public_path__ + "img/license-CC BY-NC.6f8e9e77.png";